import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { getWhatsappTemplates } from "../api.ts";
import { whatsappCampaignKeys } from "./keys.ts";
import type { SelectOption, TemplatesQueryParams } from "../../types.ts";

// Query hook for fetching WhatsApp templates
export const useWhatsappTemplatesQuery = (
  params: TemplatesQueryParams = { page: 1, pageSize: null },
) => {
  return useQuery<SelectOption[]>({
    queryKey: whatsappCampaignKeys.templates(params),
    queryFn: async () => {
      const { data } = await getWhatsappTemplates(
        params.page,
        params.pageSize ?? null,
      );

      if (!data) return [];

      const options: SelectOption[] = data.map((template) => ({
        value: template.templateId,
        label: template.templateName,
      }));

      return options;
    },
    ...reactQueryCacheAndRefetchOptions,
  });
};
